import { createMarkdownIt } from '@arianna/reader-core'
import Heading from '@arianna/design-system/Heading'
import Text from '@arianna/design-system/Text'

// Verify cross-package bundling: createMarkdownIt is imported from @arianna/reader-core.
// If this compiles and runs, the workspace alias resolution is working correctly.
const _md = createMarkdownIt()

/**
 * GAP-15: Home stub styled with DS tokens.
 * Not reachable in production (root dispatcher redirects authenticated users to /library
 * and unauthenticated users to /users/sign_in), but kept for dev-mode reference and
 * to confirm cross-package alias wiring at startup.
 */
export default function Home() {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
        padding: 'var(--space-6)',
        fontFamily: 'var(--font-sans)',
      }}
    >
      <div style={{ maxWidth: 560, textAlign: 'center' }}>
        <Heading variant="h1" style={{ color: 'var(--ink)', marginBottom: 'var(--space-4)' }}>
          Arianna Platform
        </Heading>
        <Text variant="body" style={{ color: 'var(--ink-2)', display: 'block' }}>
          Rails + Inertia + React 19 scaffold — Phase 1 running.
        </Text>
        <Text
          variant="meta"
          style={{ color: 'var(--ink-3)', display: 'block', marginTop: 'var(--space-3)' }}
        >
          Cross-package bundling check:{' '}
          <code style={{ fontFamily: 'var(--font-mono)' }}>createMarkdownIt</code> from{' '}
          <code style={{ fontFamily: 'var(--font-mono)' }}>@arianna/reader-core</code> loaded
          successfully ({_md.constructor.name}).
        </Text>
      </div>
    </div>
  )
}
